import { useNavigate } from 'react-router-dom';

interface Caminho {
  numeral: string;
  verb: string;
  title: string;
  para: string;
  to: string;
}

const CAMINHOS: Caminho[] = [
  {
    numeral: '',
    verb: 'Conheça',
    title: 'Seu Mapa Natal',
    para: 'Planetas, casas e ascendente calculados para o exato instante do seu nascimento.',
    to: '/birth-chart',
  },
  {
    numeral: '',
    verb: 'Pergunte',
    title: 'Ao Céu',
    para: 'Uma questão, uma resposta astrológica gerada especificamente para você.',
    to: '/questions',
  },
  {
    numeral: '',
    verb: 'Acompanhe',
    title: 'A Agenda Celeste',
    para: 'Próximos trânsitos, retrogradações e eventos planetários para esta semana.',
    to: '/agenda',
  },
];

export function MainActions() {
  const navigate = useNavigate();

  return (
    <section style={{ marginBottom: '2.5rem' }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '1px',
        backgroundColor: 'var(--line-soft)',
        border: '1px solid var(--line-soft)',
      }}>
        {CAMINHOS.map(({ verb, title, para, to }) => (
          <div
            key={to}
            onClick={() => navigate(to)}
            role="link"
            tabIndex={0}
            onKeyDown={e => e.key === 'Enter' && navigate(to)}
            style={{
              backgroundColor: 'var(--bg-surface)',
              padding: 'clamp(1.25rem, 3vw, 2rem) 1.5rem',
              cursor: 'pointer',
              transition: 'background-color var(--transition-fast)',
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem',
            }}
            onMouseEnter={e => { (e.currentTarget as HTMLElement).style.backgroundColor = 'var(--bg-elevated)'; }}
            onMouseLeave={e => { (e.currentTarget as HTMLElement).style.backgroundColor = 'var(--bg-surface)'; }}
          >
            {/* Verb + italic title */}
            <div>
              <p className="eyebrow" style={{ color: 'var(--celeste-soft)', marginBottom: '0.25rem' }}>
                {verb}
              </p>
              <p style={{
                fontFamily: 'var(--font-display)',
                fontStyle: 'italic',
                fontSize: 'var(--text-22)',
                fontWeight: 400,
                color: 'var(--bg)',
                margin: 0,
                lineHeight: 1.2,
              }}>
                {title}
              </p>
            </div>

            {/* Description */}
            <p style={{
              fontFamily: 'var(--font-body)',
              fontSize: 'var(--text-13)',
              color: 'var(--celeste-soft)',
              margin: 0,
              lineHeight: 1.6,
              flex: 1,
            }}>
              {para}
            </p>

            {/* Arrow */}
            <span style={{ color: 'var(--petrol)', fontSize: 'var(--text-18)', fontFamily: 'var(--font-display)' }}>→</span>
          </div>
        ))}
      </div>
    </section>
  );
}
